// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BaseDivider{display:block;width:100%;margin:0;border-top:1px solid #f2f2f5;text-align:center;position:relative;}.is-dr3-theme .BaseDivider,.is-ln4-theme .BaseDivider,.is-orange-dark-theme .BaseDivider{opacity:.3}.BaseDivider--dark{border-top-color:#D5D8DA}.BaseDivider .BaseDivider__content{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
